import f from "./useRoninNameService.js";
import * as r from "ramda";
import { useCallback as e } from "react";
const a = "0x", c = "ronin:", u = () => {
  const { maybeRNS: o } = f(), m = e(
    (t, s) => t && s ? t.toLowerCase() === s.toLowerCase() : !1,
    []
  ), i = e(
    (t) => {
      const s = (n) => r.startsWith(a, n) || r.startsWith(c, n);
      return r.isNotNil(t) && !o(t) && s(t);
    },
    [o]
  ), l = e((t) => r.isNil(t) ? "" : r.pipe(
    r.replace(c, a)
    // support ronin address (add more below)
  )(t), []);
  return {
    compareAddress: m,
    maybeAddress: i,
    toEthAddress: l
  };
};
export {
  u as default
};
//# sourceMappingURL=useWalletAddress.js.map
